import gql from 'graphql-tag'
import { /*generalSettingFragment,*/ generalSettingExtendedFragment } from "@/graphql/settings/generalSettingFragments";

export const UPSERTGENERALSETTINGS = gql`
    mutation upsertGeneralSettings (
        $settings: [upsertGeneralSettingInput!]!
    ){
        upsertGeneralSettings(
            input: $settings
        ){
            ...generalSettingExtendedFragment
        }
    }
    ${generalSettingExtendedFragment}
`